<template>
    <h1>Forgot Password</h1>
</template>

<script>
export default {

}
</script>

<style>

</style>